import {LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend} from "recharts";
import React from 'react';

export default function LineChart_ (props) {
  const { data, keys, empresasById, xName } = props;
  return (
    <LineChart width={600} height={300} data={data}
          margin={{top: 5, right: 30, left: 20, bottom: 5}}>
      <XAxis dataKey={xName} />
      <YAxis/>
      <CartesianGrid strokeDasharray="3 3"/>
      <Tooltip/>
      <Legend />
      {keys.map(k => (
        <Line type="monotone" dataKey={k} key={k} stroke={empresasById[k].Cor} activeDot={{r: 4}}/>
      ))}
    </LineChart>
  );
}
